<template>
    <div class="age-popup" v-if="popup !== false">
            <img
                src="https://static.tildacdn.com/tild3833-3530-4364-b332-393038623638/logo_dark_PERK.svg"
                alt="PERK logo"
            />
            <div class="age-buttons">
              <h1>Вам есть 18?</h1>
              <button class="btn-popup" @click="ageCheck('yes'), displayCategory ('snacks')">Да</button>
              <button class="btn-popup" @click="ageCheck('no'), displayCategory ('snacks')">Нет</button>
            </div>
    </div> 
    <div class="btn-slider" v-else>
        <button
          class="btn-slider__tabs"
        >
            <router-link to="/breakfast_menu">Завтраки</router-link>
        </button>
        <button
          class="btn-slider__tabs"
          :class="filter === btn.filter ? 'active' : ''"
          v-for="btn in buttons"
          :key="btn.id"
          @click="displayCategory(btn.filter)"
          :id="btn.filter"
        >
          <p>{{btn.title}}</p>
        </button>
    </div>
    <div class="container" > 
      <swiper
        :key="filter"
        class="mySwiper"
        ref="mySwiper"
        @slideChange="onSlideChange"
        :options="swiperPhotoOptions"
        v-if="sliderCheck !== 'text'"
      >
        <swiper-slide v-for="dish in displayArr" :key="dish.id">
          <div class="gradient-overlay">
            <img :src="dish.photo" :alt="dish.title"/>
          </div>
          <div class="text-overlay">
            <h2>{{ dish.title }}</h2>
            <p>{{dish.grammage}} / {{dish.kcal}} / <strong>{{dish.price}}</strong></p>
            <!-- Другие текстовые элементы, если необходимо -->
          </div>
        </swiper-slide>
      </swiper>
      <!-- :style="sliderCheck === 'text' ? 'padding-top: 80px' : 'padding-top: 0px'" -->
      <!-- <div class="textMargin" v-if="sliderCheck === 'text'"></div> -->
      <swiper
        class="mySwiper"
        :class="sliderCheck === 'text' ? 'textMargin': ''"
        ref="mySwiper"
        @slideChange="onSlideChange"
        :direction="'vertical'"
        :slidesPerView="3" 
        :spaceBetween="2" 
        v-if="sliderCheck === 'text'"
      >
        <swiper-slide class="text-slide" v-for="dish in displayArr" :key="dish.id">
          <div
            class="text-card"
            :key="dish.id"
            style="margin-bottom: 20px;"
          >
            
            <div class="text" style="margin-bottom: 20px;">
              <h3>{{dish.title}}</h3>
              <div class="text-info">
                <h3 style="margin-bottom: 10px;">{{dish.price}}</h3>
                <p>{{dish.grammage}} / {{dish.kcal}}</p>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import axios from 'axios'

// Import Swiper styles
import 'swiper/css';
import '../style.css';

export default {
data() {
  return {
    popup: true,
    menuArr: [],
    filter: 'snacks',
    displayArr: [],
    slider: 'photo',
    currentIndex: 0, // Добавлено для отслеживания текущего индекса слайда
    manualSlideUpdate: false, // Добавлено для ручного обновления
    swiperPhotoOptions: {
      initialSlide: 0,
    },
    swiperInitialized: false,
    buttons: [
      {id: 0, title: 'Закуски', filter: 'snacks', age: '0'},
      {id: 1, title: 'Салаты', filter: 'salads', age: '0'},
      {id: 2, title: 'Супы', filter: 'soups', age: '0'},
      {id: 3, title: 'Паста', filter: 'pasta', age: '0'},
      {id: 4, title: 'Горячее', filter: 'hotter', age: '0'},
      {id: 5, title: 'Гарниры', filter: 'garnish', age: '0'},
      {id: 8, title: 'Десерты', filter: 'dessert', age: '0'},
      {id: 9, title: 'Круассаны', filter: 'breakfastCroissants', age: '0'},
      {id: 10, title: 'Хлеб', filter: 'bread', age: '0'},
      {id: 11, title: 'Кофе', filter: 'coffee', age: '0'},
      {id: 12, title: 'Чай Домашний', filter: 'homeTea', age: '0'},
      {id: 13, title: 'Чай Классический', filter: 'classicTea', age: '0'},
      {id: 14, title: 'Домашние Лимонады', filter: 'homeLemonade', age: '0'},
      {id: 15, title: 'Авторские Коктейли', filter: 'authorCoctails', age: '18'},
      {id: 16, title: 'Классический Коктейли', filter: 'classicCoctails', age: '18'},
      {id: 17, title: 'Б/а Коктейли', filter: 'freeCocktails', age: '0'},
      {id: 18, title: 'Б/а Напитки', filter: 'freeDrinks', age: '0'},
      {id: 21, title: 'Крепкий Алкоголь', filter: 'strongAlcohol', age: '18'},
      {id: 22, title: 'Пиво', filter: 'beer', age: '18'},
      {id: 23, title: 'Белое Вино', filter: 'whiteWine', age: '18'},
      {id: 24, title: 'Красное Вино', filter: 'redWine', age: '18'},
      {id: 25, title: 'Розовое Вино', filter: 'roseWine', age: '18'},
      {id: 26, title: 'Игристое Вино', filter: 'sparkingWine', age: '18'},
      // {id: 27, title: 'Вино по бокалам', filter: 'glassOfWine', age: '18'},
    ],
  }
},
async created () {
  await this.fetchMenu()
  console.log(this.menuArr)

},
mounted() {
  console.log('mount let`s go!')
  this.displayCategory(this.filter)
},
methods: {
  async fetchMenu () {
    const { data } = await axios.get('https://vue-with-http-e0075-default-rtdb.firebaseio.com/menu.json')
    const result =  await Object.keys(data).map(key => {
      return {
        id: key,
        ...data[key]
      }
    })
    console.log(result);
    this.menuArr = result
  },
  displayCategory (id) {
    this.filter = id;
    console.log(id);

    const ctgry = this.menuArr.find(elem => elem.id === this.filter);

    // Добавьте проверку на существование ctgry
    if (ctgry) {
      let categoryArr = Object.keys(ctgry).map(key => {
        return {
          ...ctgry[key]
        };
      });
      console.log(categoryArr); 
      this.displayArr = categoryArr.slice(1).sort((a, b) => a.id > b.id ? 1 : -1);
      console.log(this.displayArr);
      this.swiperPhotoOptions = Object.assign({}, this.swiperPhotoOptions, { initialSlide: 0 });
    } else {
      console.error(`Category with id ${id} not found.`);
    }
  },
    ageCheck (answer) {
        if (answer === 'yes') {
            console.log(answer)
            document.querySelector(".age-popup").style.transition = "all 1s ease 1s"
            document.querySelector(".age-popup").style.display = "none"
            this.popup = false
            console.log(this.buttons)
        } else {
            console.log(answer)
            document.querySelector(".age-popup").style.transition = "all 1s ease 1s"
            this.buttons = this.buttons.filter(btn => btn.age !== '18')
            this.popup = false
            console.log(this.buttons)
            document.querySelector(".age-popup").style.display = "none"
        }
    },
    onSlideChange() {
        // добавляем обработчик смены слайда
      if (this.$refs.mySwiper && this.swiperInitialized) {
        const currentButtonIndex = this.buttons.findIndex(button => button.filter === this.filter);
        if (currentButtonIndex !== -1) {
            this.$refs.mySwiper.$swiper.activeIndex = currentButtonIndex;
        }
      }
    },
    },
    components: { Swiper, SwiperSlide },
    // this.filter !== "glassOfWine"
    computed: {
        sliderCheck () {
            if (this.filter !== "coffee" &&
                this.filter !== "classicTea" &&
                this.filter !== "freeDrinks" &&
                this.filter !== "whiteWine" &&
                this.filter !== "strongAlcohol" &&
                this.filter !== "beer" &&
                this.filter !== "redWine" &&
                this.filter !== "roseWine" &&
                this.filter !== "sparkingWine") {
                  console.log("photo")
                return "photo"
           } else {
            console.log("text")
                return "text"
            }
        },
    }
};
</script>

<style scoped>

.textMargin {
  /* height: 80px; */
  margin-top: 80px;
  width: 100%;
  background-color: #fff;
}

button > a {
    text-decoration: none;
    color: #41464b;
    white-space: nowrap;
}

.text-overlay {
    position: absolute;
    bottom: 10%;
    left: 4%;
    width: 92%;
    text-align: left;
    color: #fff; /* Цвет текста */
    font-family: 'Roboto';
    z-index: 1;
}

.text-overlay h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 400;
    font-family: 'Roboto';
}

.text-overlay p {
    font-size: 20px;
    font-weight: 200;
    font-family: 'Roboto';
}

.gradient-overlay {
    position: relative;
    height: 100%;
    width: 100%;
}

.gradient-overlay::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.8));
    pointer-events: none; /* Обеспечиваем, чтобы градиент не мешал взаимодействию с изображением и текстом */
}

.swiper-slide .gradient-overlay img {
    display: block;
    width: 100%;
    height: 100%;
    /* background-color: linear-gradient(90deg, black, transperent); */
    background-size: cover;

}

.active {
    font-weight: 400;   
}
</style>
